import { getNavi, getPage, getHours, getFront, getMenus, getContact, getBlogs, getReservationTexts } from '../api/contentfulAPI';
import { getDate } from '../api/dateAPI';
import { getProductsInCollection } from '../api/shopifyAPI';

export const RECEIVE_NAVI = 'RECEIVE_NAVI';
export const RECEIVE_PAGES = 'RECEIVE_PAGES';
export const RECEIVE_DATE = 'RECEIVE_DATE';
export const RECEIVE_HOURS = 'RECEIVE_HOURS';
export const RECEIVE_RESERVATION_INFO = 'RECEIVE_RESERVATION_INFO';
export const SWITCH_LANG = 'SWITCH_LANG';
export const RECEIVE_FRONTPAGE = 'RECEIVE_FRONTPAGE';
export const RECEIVE_INSTAGRAM = 'RECEIVE_INSTAGRAM';
export const RECEIVE_MENUS = 'RECEIVE_MENUS';
export const RECEIVE_CONTACT = 'RECEIVE_CONTACT';
export const RECEIVE_BLOGS = 'RECEIVE_BLOGS';
export const RECEIVE_COLLECTIONS = 'RECEIVE_COLLECTIONS';

const isFetching = {};

// filter item by time
const isItemValid = (item, time) => {
  return (!item.fields.validFrom || new Date(time) >= new Date(item.fields.validFrom))
    && (!item.fields.validUntil || new Date(time) < new Date(item.fields.validUntil));
}

export const fetchNavi = (locale) => (dispatch, state) => {
  const FLAG = 'fetchNavi';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getNavi(locale).then(items => {
      isFetching[FLAG] = false;
      dispatch(receiveNavi(items))
    });
  }
};

const receiveNavi = (items) => ({
  type: RECEIVE_NAVI,
  items: items.map(item => {
    return {...item.fields};
  }),
});

export const fetchPage = (slug, locale) => (dispatch) => {
  const FLAG = `fetchPage_${slug}`;
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getPage(slug, locale).then(item => {
      isFetching[FLAG] = false;
      dispatch(receivePage(item))
    });
  }
}

const receivePage = (item) => {
  return {
    type: RECEIVE_PAGES,
    item
  }
}

// fetch and get the front page head
export const fetchFront = (locale, time) => (dispatch) => {
  const FLAG = 'fetchFront';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getFront(locale).then(item => {
      isFetching[FLAG] = false;
      dispatch(receiveFront(item, time));
    })
  }
}

const receiveFront = (data, time) => {
  return {
    type: RECEIVE_FRONTPAGE,
    data: {
      header:data.header,
      showLiftsHeading:data.showLiftsHeading,
      lifts:data.lifts?data.lifts.filter(lift => isItemValid(lift, time)):null,
      containers: data.containers ? data.containers.filter(container => isItemValid(container, time)) : null,
      contactPage: data.contactPage
    }
  }
}


export const fetchDate = () => (dispatch) => {
  const FLAG = 'fetchDate';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getDate().then(date => {
      isFetching[FLAG] = false;
      dispatch(receiveDate(date))
    })
  }
};

const receiveDate = (date) => ({
  type: RECEIVE_DATE,
  date,
});


export const fetchReservationTexts = (locale) => (dispatch) => {
  const FLAG = 'fetchReservationTexts';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getReservationTexts(locale).then(texts => {
      isFetching[FLAG] = false;
      dispatch(receiveReservationTexts(texts))
    })
  }
}

const receiveReservationTexts = (texts) => ({
  type: RECEIVE_RESERVATION_INFO,
  texts
})

// fetch and receive the open hours text
export const fetchHours = (locale) => (dispatch) => {
  const FLAG = 'fetchHours';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getHours(locale).then(text => {
      isFetching[FLAG] = false;
      dispatch(receiveHours(text))
    })
  }
}

const receiveHours = (hoursText) => ({
  type: RECEIVE_HOURS,
  hoursText
})

export const switchLang = () => ({
  type: SWITCH_LANG
});

// fetch and receive instagram

export const fetchInstagram = () => (dispatch) => {
  const FLAG = "fetchInstagram";
  isFetching[FLAG] = true;
  
  const site_name = process.env.REACT_APP_INSTAGRAM_SITE_NAME;
  var today = new Date();

  const timestamp = today.getFullYear() + "" + (today.getMonth() +1) + "" + today.getDate() + "" + today.getHours();
  return fetch(`https://instagram.monkfish.fi/cache/${site_name}.json?c=${timestamp}`)
    .then(x=>{
      return x.json()
    })
    .then(y=>{
      dispatch(receiveInstagram(y.data));
    })
}

/*export const fetchInstagram = () => (dispatch) => {
  const FLAG = "fetchInstagram";
  isFetching[FLAG] = true;
  return fetch('https://ottoboni.fi.cloudplatform.fi/helpers/instagram/GetLatestInstagramImages.php?user=6074094245&count=2&access_token=6074094245.1677ed0.1c9c9c4b17e043a5a9290ad16e075680')
    .then(x=>x.json())
    .then(y=>{
      dispatch(receiveInstagram(JSON.parse(y).data));
    })
}*/

const receiveInstagram = (data) => {
  const FLAG = "fetchInstagram";
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_INSTAGRAM,
    data
  };
}

// fetch and receive menu data
export const fetchMenu = (time, locale) => (dispatch) => {
  const FLAG = "fetchMenu";
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getMenus(locale).then(data =>
      dispatch(receiveMenus(data, time))
    )
  }
}

const receiveMenus = (menus, time) => {
  const FLAG = "fetchMenu";
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_MENUS,
    data: menus.filter(menu => isItemValid(menu, time))
  };
}

// fetch and receive the contact page content
export const fetchContact = (locale) => (dispatch) => {
  const FLAG = 'fetchContact';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getContact(locale).then(data => {
      isFetching[FLAG] = false;
      dispatch(receiveContact(data))
    })
  }
}

const receiveContact = (data) => {
  return {
    type: RECEIVE_CONTACT,
    data
  }
}

export const fetchBlog = (locale, limit, offset) => (dispatch) => {
  const FLAG = 'fetchBlog';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getBlogs(locale, limit, offset).then(data => {
      dispatch(receiveBlogs(data))
    });
  }
};

const receiveBlogs = (blogs) => {
  const FLAG = 'fetchBlog';
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_BLOGS,
    data: blogs
  };
};

export const fetchCollection = (id) => (dispatch) => {
  const FLAG = 'fetchGiftCard';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getProductsInCollection(id).then(collection => {
      isFetching[FLAG] = false;
      dispatch(receiveCollection(collection))
    });
  }
};

const receiveCollection = (collection) => ({
  type: RECEIVE_COLLECTIONS,
  collection
});



// WEBPACK FOOTER //
// ./src/redux/actions.js